import { createPinia } from "pinia";
import createPersistedState from "pinia-plugin-persistedstate";
// Inicializa Pinia
const pinia = createPinia();
pinia.use(createPersistedState);

export default pinia;
